import {
  ChevronDownIcon,
  ChevronsUpIcon,
  ChevronUpIcon,
  type LucideIcon,
  PauseIcon,
} from "lucide-react";

import { Center } from "@/components/Center";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

import { cn } from "@/lib/utils";
import { JobPriority } from "@/types";

const PRIORITY_CONFIG: Record<
  JobPriority,
  { icon: LucideIcon; chipClassName: string; iconClassName: string }
> = {
  [JobPriority.HIGH]: {
    icon: ChevronsUpIcon,
    chipClassName: "bg-lever-surface-error text-lever-text-error",
    iconClassName: "text-lever-text-error",
  },
  [JobPriority.MEDIUM]: {
    icon: ChevronUpIcon,
    chipClassName: "bg-lever-surface-warning text-lever-text-warning",
    iconClassName: "text-lever-text-warning",
  },
  [JobPriority.LOW]: {
    icon: ChevronDownIcon,
    chipClassName: "bg-lever-surface-information text-lever-text-information",
    iconClassName: "text-lever-text-information",
  },
  [JobPriority.BACKBURNERED]: {
    icon: PauseIcon,
    chipClassName: "bg-lever-surface-neutral text-lever-text-neutral",
    iconClassName: "text-lever-text-neutral",
  },
};

export const DashboardPriorityCell = ({
  priority,
}: {
  priority: JobPriority | null;
}) => {
  const render = () => {
    if (priority === null) {
      return (
        <Row className="justify-start">
          <Center className="h-6 w-6 rounded-full">
            <Text className="text-sm font-normal text-lever-text-disabled">
              —
            </Text>
          </Center>
        </Row>
      );
    }

    const config = PRIORITY_CONFIG[priority];
    const Icon = config.icon;
    return (
      <Row className="justify-start">
        <Center className={cn("h-6 w-6 rounded-full", config.chipClassName)}>
          <Icon
            className={cn("h-3 w-3 shrink-0", config.iconClassName)}
            strokeWidth={2}
          />
        </Center>
      </Row>
    );
  };

  return render();
};
